<template>
  <div class="period-configuration">
    <!-- SELEÇÃO DE APARTAMENTOS -->
    <div v-if="fluctuationData.tipoCoeficiente === 0" class="form--title">
      <PmwFormSelect
        v-model="selectedRooms"
        :options="apartmentsOptions"
        :search="true"
        :multiple="true"
        label="Apartamentos com essa flutuação"
        placeholder="Selecione os apartamentos"
        class="form--input form--input__select"
      />
    </div>

    <!-- TITULO -->
    <div v-if="showAllotmentTable" class="form--title">
      <PmwHeading size="paragraph-80" weight="weight-light">
        Allotment por acomodação
      </PmwHeading>
    </div>

    <!-- TABEL DE EDIÇÃO DE ALLOTMENT -->
    <AllotmentEditionTable
      v-if="showAllotmentTable"
      :allotmentRooms="fluctuationData.allotmentQuartos"
      :hotelRoomsData="hotelRoomsData"
      class="form--row"
    />

    <!-- TITULO -->
    <div class="form--title">
      <PmwHeading size="paragraph-80" weight="weight-light">
        Dispositivos

        <InfoTooltip
          :tooltipMinWidth="'285'"
          text="Selecione em qual dispositivo essa regra tarifária deve estar disponível para vendas ao hóspede."
        />
      </PmwHeading>
    </div>

    <!-- CHECKBOX DE DISPOSITIVO MOBILE -->
    <div class="form--row__small">
      <InputCheckbox
        v-model="fluctuationData.devices"
        :inputValue="'1'"
        :checked="fluctuationData.devices?.includes('1')"
        label="Mobile"
        name="device"
        class="form--input__checkbox"
      />

      <!-- CHECKBOX DE DISPOSITIVO DESKTOP -->
      <InputCheckbox
        v-model="fluctuationData.devices"
        :inputValue="'0'"
        :checked="fluctuationData.devices?.includes('0')"
        label="Desktop"
        name="device"
        class="form--input__checkbox"
      />
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'
import AllotmentEditionTable from './AllotmentEditionTable'

export default {
  name: 'AllotmentPerAccommodation',
  components: {
    PmwHeading,
    PmwFormSelect,
    InfoTooltip,
    InputCheckbox,
    AllotmentEditionTable
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    hotelRoomsData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showAllotmentTable: false,

      apartmentsOptions: [],

      selectedRooms: []
    }
  },

  watch: {
    hotelRoomsData(rooms) {
      this.handleHotelData(rooms)
    },

    'fluctuationData.quartos'() {
      this.verifyRoomsAllotments()

      this.handleAllotmentData(this.fluctuationData.tipoCoeficiente)
    },

    'fluctuationData.precosQuartos': {
      handler() {
        this.handleAllotmentData(this.fluctuationData.tipoCoeficiente)
      },
      deep: true
    },

    'fluctuationData.tipoCoeficiente'(newVal) {
      this.fluctuationData.allotmentQuartos = []
      this.fluctuationData.quartos = []
      this.selectedRooms = []

      if (newVal !== 1) {
        this.showAllotmentTable = false
      }
    },

    selectedRooms(newValue, oldValue) {
      if (!this.fluctuationData.quartos) this.fluctuationData.quartos = []

      if (!this.fluctuationData.allotmentQuartos)
        this.fluctuationData.allotmentQuartos = []

      /** Quando todos os apartamentos estiverem selecionados, quartos recebe array vazio */
      if (
        newValue.length === this.apartmentsOptions.length &&
        this.fluctuationData.tipoCoeficiente === 0
      ) {
        this.fluctuationData.quartos = []
        this.showAllotmentTable = true

        this.selectedRooms.forEach((item) => {
          /** Verifica se já não existe o valor, caso seja uma edição para não duplicar */
          if (
            !this.fluctuationData.allotmentQuartos.find(
              (aItem) => +aItem.codigoQuarto === +item.value
            )
          ) {
            this.fillAllotmentTable(item)
          }
        })

        return
      }

      if (
        newValue.length > oldValue.length &&
        this.fluctuationData.tipoCoeficiente === 0
      ) {
        const diff = this.getArrayDiffValue(newValue, oldValue)

        diff.forEach((diffItem) => {
          /** Verifica se já não existe o valor, caso seja uma edição para não duplicar */
          if (
            !this.fluctuationData.quartos.find(
              (qItem) => +qItem === +diffItem.value
            )
          ) {
            this.fluctuationData.quartos.push(diffItem.value)
          }

          /** Verifica se já não existe o valor, caso seja uma edição para não duplicar */
          if (
            !this.fluctuationData.allotmentQuartos.find(
              (aItem) => +aItem.codigoQuarto === +diffItem.value
            )
          ) {
            this.fillAllotmentTable(diffItem)
          }

          this.fluctuationData.allotmentQuartos.sort(
            (a, b) => a.codigoQuarto - b.codigoQuarto
          )
        })
      } else {
        this.fluctuationData.quartos = newValue.map((item) => +item.value)
      }

      if (!this.fluctuationData.allotmentQuartos.length) {
        this.showAllotmentTable = false
      } else if (this.fluctuationData.allotmentQuartos?.length >= 1) {
        this.showAllotmentTable = true
      }
    }
  },

  async created() {
    if (
      this.fluctuationData.tipoCoeficiente === 0 &&
      this.fluctuationData.quartos?.length
    ) {
      await this.handleHotelData(this.hotelRoomsData)
    }

    if (this.fluctuationData.precosQuartos?.length && this.hotelRoomsData) {
      await this.handleAllotmentData(this.fluctuationData.tipoCoeficiente)
    }

    if (this.fluctuationData.tipoCoeficiente !== 1) {
      this.verifyRoomsAllotments()
    }

    /* Ajusta os dados de device no retorno */
    if (this.fluctuationData.devices?.length >= 1) {
      this.fluctuationData.devices.forEach((device, index, arr) => {
        arr[index] = device.toString()
      })
    } else {
      this.fluctuationData.devices = []
    }
  },

  methods: {
    fillAllotmentTable(item) {
      this.fluctuationData.allotmentQuartos.push({
        codigoQuarto: item.value,
        allotment: null,
        allotmentExclusivoTarifa: false
      })
    },

    async handleAllotmentData(value) {
      if (value === 1) {
        if (!this.fluctuationData.allotmentQuartos) {
          this.fluctuationData.allotmentQuartos = []
        }

        const filteredRoomsPrice = await this.fluctuationData.precosQuartos.filter(
          (quarto) => {
            return quarto.valoresOcupantes.every(
              (ocupante) => ocupante.valor !== null && ocupante.valor !== ''
            )
          }
        )

        await filteredRoomsPrice.forEach((room) => {
          const existingAllotment = this.fluctuationData.allotmentQuartos.find(
            (item) => item.codigoQuarto === room.codigoQuarto
          )

          if (!existingAllotment) {
            const hotelRoom = this.hotelRoomsData.find(
              (item) => item.codigo === room.codigoQuarto
            )

            if (hotelRoom) {
              this.fluctuationData.allotmentQuartos.push({
                codigoQuarto: hotelRoom.codigo,
                allotment: null,
                allotmentExclusivoTarifa: false
              })
            }

            this.fluctuationData.allotmentQuartos = this.fluctuationData.allotmentQuartos.sort(
              (a, b) => a.codigoQuarto - b.codigoQuarto
            )
          }
        })

        this.showAllotmentTable =
          this.fluctuationData.allotmentQuartos.length > 0
      }
    },

    async handleHotelData(rooms) {
      /** Tratamento dos dados de quartos do hotel */
      await rooms.forEach((room) => {
        if (room.ativo === true) {
          this.apartmentsOptions.push({
            text: room.nome,
            value: room.codigo,
            allotment: null,
            allotmentExclusivoTarifa: false
          })
        }
      })

      await this.apartmentsOptions.sort((a, b) => a.value - b.value)

      if (this.fluctuationData.tipoCoeficiente === 0) {
        this.selectedRooms = this.apartmentsOptions.filter((item) =>
          this.fluctuationData.quartos?.find((code) => +code === +item.value)
        )
      }

      if (this.$route.name === 'RateFluctuationsCreate') {
        this.selectedRooms = this.apartmentsOptions
      }
    },

    getArrayDiffValue(arr1, arr2) {
      return arr1.filter(
        (item1) => !arr2.find((item2) => item1.value === item2.value)
      )
    },
    verifyRoomsAllotments() {
      if (this.fluctuationData.quartos.length) {
        this.fluctuationData.allotmentQuartos = this.fluctuationData.allotmentQuartos?.filter(
          (item) => this.fluctuationData.quartos?.includes(item.codigoQuarto)
        )

        return
      }

      /** Se não possuí quartos selecionados, considera todos */
      this.fluctuationData.allotmentQuartos = this.fluctuationData.allotmentQuartos?.filter(
        (item) =>
          this.selectedRooms?.find(
            (rItem) => +rItem.value === +item.codigoQuarto
          )
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  &--button {
    width: 175px;
  }

  &--input {
    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }
      .pmw-form-field--label {
        font-weight: font-weight('weight-medium');
      }
      .form-field--label-wrapper {
        line-height: 21px;
        margin-bottom: 3px;
      }
      .pmw-input {
        background: $white;
      }
      .pmw-input--clear {
        z-index: 0;
      }
      .pmw-input__focus {
        border-color: $pmw-blue;
      }

      .pmw-input--field {
        background: $pmw-white;

        &:focus {
          border-color: $pmw-blue;
        }
      }

      .pmw-input__disabled {
        input {
          background: pmw-colors('grey-20');
          color: $pmw-gray-darker;
        }
      }

      .pmw-custom-tooltip {
        line-height: 18px;
      }
    }

    &__select {
      width: 435px;
      max-width: 435px;

      ::v-deep {
        .pmw-label {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: auto;
        }
      }

      &.error {
        ::v-deep {
          .pmw-select--button {
            border-bottom-color: pmw-colors('error-100');
            border-bottom-width: 2px;
          }
        }
      }
    }

    &__checkbox {
      width: 75px;
      max-width: 75px;
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 32px;

    &__small {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 24px;
      margin-bottom: 16px;
    }
  }

  &--title {
    margin-bottom: 24px;
    position: relative;
  }
}
</style>
